export default __webpack_public_path__ + "static/media/img_card_bg.65279c47.png";